import React from 'react';

function NoMatch() {
  return <div>NoMatch</div>;
}

export default NoMatch;
